(function(){
"use strict";

angular.module("swapick")
.factory('Enums', Enums);

function Enums(){
    var svc = {}

    svc.conditions = {
      default : [
        { value:0, label:"Scarse: Molto vissuto ma ancora utilizzabile" },
        { value:1, label:"Buone: utilizzato più volte ma ancora accettabile" },
        { value:2, label:"Ottime: Usato una sola volta e messo via" },
        { value:3, label:"Nuovo: Mai utilizzato"}
      ],

      50 : [
        { value: 0, label : "Fair (F)" },
        { value: 1, label : "Poor (P)" },
        { value: 2, label : "Good (G)" },
        { value: 3, label : "Good Plus (G+)" },
        { value: 4, label : "Very Good (VG)" },
        { value: 5, label : "Very Good Plus (VG+)" },
        { value: 6, label : "Near Mint (NM)" },
        { value: 7, label : "Mint (M)" }
      ]
    }

    svc.getConditionsOptions = cat => {

      return svc.conditions[parseInt(cat)] || svc.conditions['default'];

    }


    return svc;
}



})();



// WEBPACK FOOTER //
// ./src/services/enums-service.js